
import BaseSvg from "@/components/base/BaseSvg.vue";
import useAccount from "@/composables/useAccount";
import useAccountNavigation from "@/composables/useAccountNavigation";
import { useUserStore } from "@/store/user";
import { computed, defineComponent } from "vue";
import BaseButton from "../base/BaseButton.vue";
import { UserType } from "@/models/enums";
import { useBookingStore } from "@/store/booking";
import { useCampaignStore } from "@/store/campaign";

export default defineComponent({
	components: {
		BaseSvg,
		BaseButton,
	},
	setup() {
		const userStore = useUserStore();
		const { components, goToPage, currentPage, resetBooking, accountLoading } = useAccountNavigation();
		const { logout, loading } = useAccount();
		const bookingStore = useBookingStore();
		const campaignStore = useCampaignStore();

		const user = computed(() => userStore.getUser);
		
		const newBooking = function() {
				accountLoading.value = true;
				
				resetBooking()
				.then((resp) => {
					bookingStore.$reset();
					campaignStore.$reset();
					window.location.href = resp;
				});
		}
		
		return { components, currentPage, goToPage, user, logout, loading, newBooking, UserType };
	},
});
